"use client";
import { useMantineContext } from "../../../core/MantineProvider/Mantine.context.mjs";
import { useMantineTheme } from "../../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs";
import { InlineStyles } from "../../../core/InlineStyles/InlineStyles.mjs";
import { getVariables } from "./get-variables/get-variables.mjs";
import { jsx } from "react/jsx-runtime";
//#region packages/@mantine/core/src/components/AppShell/AppShellMediaStyles/AppShellMediaStyles.tsx
function AppShellMediaStyles({ navbar, header, aside, footer, padding, mode, selector }) {
	const theme = useMantineTheme();
	const ctx = useMantineContext();
	const { media, baseStyles } = getVariables({
		navbar,
		header,
		footer,
		aside,
		padding,
		theme,
		mode
	});
	return /* @__PURE__ */ jsx(InlineStyles, {
		media,
		styles: baseStyles,
		selector: selector || ctx.cssVariablesSelector
	});
}
//#endregion
export { AppShellMediaStyles };

//# sourceMappingURL=AppShellMediaStyles.mjs.map